import React from "react";
import {useLoaderData} from "react-router-dom";
import {useBreakpoint, VStack} from "@chakra-ui/react";
import client from "../../../../helpers/Client";
import request2APIParams from "../../../../helpers/request2APIParams";
import ProjectListCardView from "./ProjectListCardView";
import ProjectListTableView from "./ProjectListTableView";
import ProjectFilterBar from "./ProjectFilterBar";

export async function ProjectListLoader({ request }) {
  const params = request2APIParams(request);
  
  // Remove empty string params
  Object.keys(params).forEach(key => {
    if (params[key] === "") {
      delete params[key];
    }
  });

  // Validate city parameter is numeric
  if (params.city && isNaN(Number(params.city))) {
    delete params.city;
  }
  
  console.log("ProjectListLoader params:", params);
  const resp = await client.get("/projects/", { params });
  return resp.data;
}

export default function ProjectList() {
  const bp = useBreakpoint({ssr: false});
  const data = useLoaderData()
  const Component = {
    'base': ProjectListCardView, 'sm': ProjectListTableView, 'md': ProjectListTableView, 'lg': ProjectListTableView,
  }[bp] || ProjectListTableView
  
  return (
    <VStack spacing={4} align="stretch" w="full">
      <ProjectFilterBar />
      <Component Project={data}/>
    </VStack>
  );
}
